import {OrganizationPermissions} from './organization-group/organization.permissions';

export const USER_MANAGEMENT_PERMISSIONS = {
  VIEW: 'list_users',
  CREATE: 'create_user',
  UPDATE: 'update_user',
  DELETE: 'delete_user',
} as const;

export type UserManagementPermissions = typeof USER_MANAGEMENT_PERMISSIONS[keyof typeof USER_MANAGEMENT_PERMISSIONS]
  | OrganizationPermissions;
